import type { MiaEventName } from '../types';

type Handler = (payload?: unknown) => void;

export class EventBus {
  private listeners = new Map<MiaEventName, Set<Handler>>();

  on(event: MiaEventName, handler: Handler): () => void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(handler);
    return () => this.off(event, handler);
  }

  off(event: MiaEventName, handler: Handler): void {
    this.listeners.get(event)?.delete(handler);
  }

  emit(event: MiaEventName, payload?: unknown): void {
    const set = this.listeners.get(event);
    if (!set) return;
    for (const handler of Array.from(set)) {
      try {
        handler(payload);
      } catch {
        // never break widget on consumer handler errors
      }
    }
  }

  clear(): void {
    this.listeners.clear();
  }
}
